import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ComisionMedicaRequest, ComisionMedicaResponse, ExpedienteComisionMedicaResponse } from '../models/comision-medica.interface';
import { BackendAuthService } from './backend-auth.service';
import { SessionService } from './session.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ComisionMedicaService {

  constructor(private api: ApiService, private authService: BackendAuthService, private http: HttpClient, private sessionService: SessionService) { }

  async registrarSesion(data: ComisionMedicaRequest): Promise<{ success: string, data: ComisionMedicaResponse }> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const http = this.http.post<{ success: string, data: ComisionMedicaResponse }>(
      `${environment.backendUrl}/esi-comision-medica`,
      data,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'session_id': this.sessionService.getToken() || ''
        }
      }
    );
    return firstValueFrom(http);
  }

  async obtenerExpediente(expId: number): Promise<{ success: string, data: ExpedienteComisionMedicaResponse }> {
    const tokenRes = await this.authService.obtenerToken();
    const token = tokenRes.access_token;
    const http = this.http.post<{ success: string, data: ExpedienteComisionMedicaResponse }>(
      `${environment.backendUrl}/esi-expediente-comision-medica?exp_id=${expId}`,
      {},
      {
        headers: {
          'Authorization': `Bearer ${token}`,
          'session_id': this.sessionService.getToken() || ''
        }
      }
    );
    return firstValueFrom(http);
  }
}
